export const platformMeta = {
  douyin: { label: '抖音', color: '#111216' },
  xiaohongshu: { label: '小红书', color: '#ef4248' },
  kuaishou: { label: '快手', color: '#ff5b24' },
  wechat: { label: '视频号', color: '#22a65b' },
}

export const contentTypeLabels = { video: '短视频', image: '图文', live: 'Live 图' }
export const referenceTypeLabels = { video: '视频', image: '图文', live: 'Live 图' }
export const assetStatusLabels = { unpublished: '未发布', published: '已发布' }
export const planStatusLabels = { pending: '待发布', next: '即将发布', published: '已发布' }
export const memberRoleLabels = { owner: '超级管理员', operator: '运营', editor: '编辑', viewer: '访客' }

export function formatMetric(value) {
  if (value >= 10000) return `${(value / 10000).toFixed(value >= 100000 ? 1 : 2).replace(/\.?0+$/, '')}万`
  return new Intl.NumberFormat('zh-CN').format(value)
}

export function formatDateTime(value) {
  const date = new Date(value)
  return `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
}
